var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('national-tag-path-mutation',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var updateNationalTagPath = ref.updateNationalTagPath;
return [_c('el-checkbox',{attrs:{"checked":_vm.nationalTagPath.is_available},on:{"change":function($event){return updateNationalTagPath(_vm.nationalTagPath.id, { is_available: $event })}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }